document.addEventListener('DOMContentLoaded', function() {

// ── DATA ─────────────────────────────────────────────────────────
// Variant titles in Shopify: "US Tree / 5", "US Tree / 10" etc.
// Liquid injects these via pat-variant-data script tag on the live page.
// variantMap is built from that injection; keys are lowercase title.
var variantMap = {};
var patEl = document.getElementById('pat-variant-data');
if (patEl) {
  try {
    JSON.parse(patEl.textContent).forEach(function(v) {
      variantMap[v.title.toLowerCase()] = v.id;
    });
    console.log('[KAT] Variants loaded:', variantMap);
  } catch(e) { console.error('[KAT] Variant parse error:', e); }
}

// Preset data — source of truth for trees/price/per-tree cost and variant lookup
var PRESETS = {
  us: [
    { key:'us-5',   qty:5,   price:50,  per:'10.00', variantTitle:'us tree / 5'   },
    { key:'us-10',  qty:10,  price:95,  per:'9.50',  variantTitle:'us tree / 10'  },
    { key:'us-25',  qty:25,  price:225, per:'9.00',  variantTitle:'us tree / 25'  },
    { key:'us-50',  qty:50,  price:425, per:'8.50',  variantTitle:'us tree / 50'  },
    { key:'us-100', qty:100, price:800, per:'8.00',  variantTitle:'us tree / 100' }
  ],
  in: [
    { key:'in-5',   qty:5,   price:40,  per:'8.00',  variantTitle:'india tree / 5'   },
    { key:'in-10',  qty:10,  price:75,  per:'7.50',  variantTitle:'india tree / 10'  },
    { key:'in-25',  qty:25,  price:175, per:'7.00',  variantTitle:'india tree / 25'  },
    { key:'in-50',  qty:50,  price:325, per:'6.50',  variantTitle:'india tree / 50'  },
    { key:'in-100', qty:100, price:600, per:'6.00',  variantTitle:'india tree / 100' }
  ]
};

var LOCS = {
  us: { label:'United States', flag:'🇺🇸', namePh:'e.g. Sarah Johnson', emailPh:'e.g. sarah@example.com' },
  in: { label:'India',         flag:'🇮🇳', namePh:'e.g. Priya Sharma',  emailPh:'e.g. priya@example.com' }
};

var curLoc    = 'us';
var curPreset = PRESETS.us[0]; // default: US 5 trees

// ── GET CURRENT SELECTED PRESET ──────────────────────────────────
function getSelectedPreset() {
  var name    = curLoc === 'us' ? 'preset-us' : 'preset-in';
  var checked = document.querySelector('input[name="' + name + '"]:checked');
  if (!checked) return PRESETS[curLoc][0];
  var key = checked.value;
  return PRESETS[curLoc].find(function(p){ return p.key === key; }) || PRESETS[curLoc][0];
}

// ── SYNC ALL UI ───────────────────────────────────────────────────
function syncUI() {
  curPreset = getSelectedPreset();
  var L = LOCS[curLoc];
  var treesLbl = curPreset.qty + ' tree' + (curPreset.qty > 1 ? 's' : '');

  // Price display
  document.getElementById('price-display').innerHTML = '<sup>$</sup>' + curPreset.price;
  document.getElementById('price-note').textContent  = '$' + curPreset.per + ' per tree · One-time payment';

  // Total strip
  document.getElementById('total-trees-lbl').textContent  = treesLbl;
  document.getElementById('total-price-per').textContent  = '$' + curPreset.per;
  document.getElementById('total-amount').textContent     = curPreset.price;

  // ATC button
  document.getElementById('atc-total').textContent = curPreset.price;

  // Image badge
  document.getElementById('img-qty-label').textContent = curPreset.qty + (curPreset.qty === 1 ? ' TREE' : ' TREES');
  document.getElementById('img-loc-label').textContent = L.label;
  document.getElementById('img-total').textContent     = '$' + curPreset.price;

  // Below-image
  document.getElementById('below-label').textContent = treesLbl + ' · ' + L.label;
  document.getElementById('below-price').textContent = '$' + curPreset.per + ' per tree';

  // Breadcrumb
  document.getElementById('bc-text').textContent = 'Plant a Tree — ' + L.label;
}

// ── LOCATION SWITCH ───────────────────────────────────────────────
window.switchLoc = function(loc) {
  curLoc = loc;
  var L = LOCS[loc];

  // Show correct preset panel
  document.getElementById('panel-us').classList.toggle('active', loc === 'us');
  document.getElementById('panel-in').classList.toggle('active', loc === 'in');

  // Reset to first preset in the new location
  var firstRadio = document.querySelector('input[name="preset-' + loc + '"]');
  if (firstRadio) firstRadio.checked = true;

  // Update tagline and placeholders
  document.getElementById('tagline').textContent = loc === 'us'
    ? 'A one-time tree-planting purchase with a personalised certificate and verified GPS location of the planting site. No subscription.'
    : 'A one-time tree-planting purchase in India with a personalised certificate and GPS coordinates for the verified planting site. No subscription.';

  if (!document.getElementById('is-gift').checked) {
    document.getElementById('cert-name').placeholder  = L.namePh;
    document.getElementById('cert-email').placeholder = L.emailPh;
  }

  syncUI();
}

// Attach listeners to all preset radios
document.querySelectorAll('input[name="preset-us"], input[name="preset-in"]').forEach(function(r) {
  r.addEventListener('change', syncUI);
});

// ── GIFT TOGGLE ───────────────────────────────────────────────────
window.toggleGift = function(cb) {
  var section  = document.getElementById('gift-sender-section');
  var desc     = document.getElementById('cert-desc');
  var nameL    = document.getElementById('cert-name-label');
  var emailL   = document.getElementById('cert-email-label');
  var nameIn   = document.getElementById('cert-name');
  var emailIn  = document.getElementById('cert-email');
  var L        = LOCS[curLoc];
  if (cb.checked) {
    section.classList.add('visible');
    desc.textContent   = "Enter the recipient's details. The certificate will be personalised with their name and emailed directly to them.";
    nameL.textContent  = "Recipient's name (on certificate)";
    emailL.textContent = "Recipient's email (certificate sent here)";
    nameIn.placeholder  = L.namePh;
    emailIn.placeholder = L.emailPh;
  } else {
    section.classList.remove('visible');
    desc.textContent   = 'Your digital planting certificate will be personalised with this name and emailed automatically after purchase.';
    nameL.textContent  = 'Name on certificate';
    emailL.textContent = 'Email to send certificate to';
    nameIn.placeholder  = L.namePh;
    emailIn.placeholder = L.emailPh;
    document.getElementById('sender-name').value  = '';
    document.getElementById('gift-message').value = '';
  }
}

// ── CERTIFICATE SVG ───────────────────────────────────────────────
function buildCertSVG(name, trees, location) {
  var d      = new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
  var emoji  = location === 'India' ? '🌿' : '🌲';
  var emojis = '';
  for (var i = 0; i < Math.min(trees, 10); i++) emojis += emoji;
  return '<svg viewBox="0 0 800 566" xmlns="http://www.w3.org/2000/svg" font-family="Georgia,serif">'
  + '<defs>'
  + '<linearGradient id="cb" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#E8F9F0"/><stop offset="100%" stop-color="#C8EDD8"/></linearGradient>'
  + '<linearGradient id="ch" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#2C7B4F"/><stop offset="50%" stop-color="#3a9060"/><stop offset="100%" stop-color="#2C7B4F"/></linearGradient>'
  + '</defs>'
  + '<rect width="800" height="566" fill="url(#cb)"/>'
  + '<rect x="12" y="12" width="776" height="542" rx="4" fill="none" stroke="#023D8B" stroke-width="1.5" opacity=".35"/>'
  + '<rect x="22" y="22" width="756" height="522" rx="3" fill="none" stroke="#023D8B" stroke-width=".75" stroke-dasharray="5,5" opacity=".2"/>'
  + '<rect x="12" y="12" width="776" height="78" rx="4" fill="url(#ch)"/>'
  + '<rect x="12" y="76" width="776" height="14" fill="#2C7B4F"/>'
  + '<rect x="12" y="476" width="776" height="66" rx="4" fill="url(#ch)"/>'
  + '<rect x="12" y="476" width="776" height="14" fill="#2C7B4F"/>'
  + '<text x="400" y="52" text-anchor="middle" font-size="22" fill="#EFECEC" letter-spacing="8">KARMIC AVSAR</text>'
  + '<text x="400" y="72" text-anchor="middle" font-size="10" fill="rgba(217,243,229,.65)" letter-spacing="4">karmicavsar.com</text>'
  + '<text x="36" y="126" font-size="18" fill="#2C7B4F" opacity=".45">🌿</text>'
  + '<text x="764" y="126" font-size="18" fill="#2C7B4F" opacity=".45" text-anchor="end">🌿</text>'
  + '<text x="36" y="466" font-size="18" fill="#2C7B4F" opacity=".45">🌿</text>'
  + '<text x="764" y="466" font-size="18" fill="#2C7B4F" opacity=".45" text-anchor="end">🌿</text>'
  + '<text x="400" y="142" text-anchor="middle" font-size="11" fill="#023D8B" letter-spacing="7" opacity=".5">CERTIFICATE OF</text>'
  + '<text x="400" y="175" text-anchor="middle" font-size="38" font-weight="300" fill="#023D8B" letter-spacing="1">Tree Planting</text>'
  + '<line x1="180" y1="192" x2="620" y2="192" stroke="#2C7B4F" stroke-width="1" opacity=".4"/>'
  + '<text x="400" y="224" text-anchor="middle" font-size="13" fill="#023D8B" opacity=".55" letter-spacing="2">This certifies that</text>'
  + '<text x="400" y="282" text-anchor="middle" font-size="48" font-weight="400" fill="#023D8B">' + (name || 'Your Name') + '</text>'
  + '<line x1="120" y1="295" x2="680" y2="295" stroke="#2C7B4F" stroke-width="1.5" opacity=".5"/>'
  + '<text x="400" y="328" text-anchor="middle" font-size="14" fill="#023D8B" opacity=".6">has planted</text>'
  + '<text x="400" y="368" text-anchor="middle" font-size="20" fill="#2C7B4F">' + trees + ' tree' + (trees > 1 ? 's' : '') + ' in ' + location + '</text>'
  + '<text x="400" y="404" text-anchor="middle" font-size="22">' + emojis + '</text>'
  + '<text x="400" y="436" text-anchor="middle" font-size="12" fill="#023D8B" opacity=".45">Planted ' + d + ' · In partnership with ReThink</text>'
  + '<text x="400" y="503" text-anchor="middle" font-size="11" fill="#EFECEC" opacity=".85" letter-spacing="3">GOOD KARMA. BY CHOICE.</text>'
  + '<text x="400" y="522" text-anchor="middle" font-size="9" fill="rgba(239,236,236,.5)" letter-spacing="1">karmicavsar.com</text>'
  + '</svg>';
}

window.previewCert = function() {
  var name = document.getElementById('cert-name').value.trim() || 'Your Name Here';
  document.getElementById('cert-svg-wrap').innerHTML = buildCertSVG(name, curPreset.qty, LOCS[curLoc].label);
  document.getElementById('cert-modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}
window.closeCert = function() {
  document.getElementById('cert-modal').classList.remove('open');
  document.body.style.overflow = '';
}
window.downloadCert = function() {
  var svg  = document.querySelector('#cert-svg-wrap svg');
  var data = new XMLSerializer().serializeToString(svg);
  var blob = new Blob([data], {type:'image/svg+xml'});
  var url  = URL.createObjectURL(blob);
  var a    = document.createElement('a');
  a.href = url; a.download = 'karmic-avsar-certificate.svg'; a.click();
  URL.revokeObjectURL(url);
}

// ── ADD TO CART ───────────────────────────────────────────────────
window.addToCart = function() {
  var certName    = document.getElementById('cert-name').value.trim();
  var certEmail   = document.getElementById('cert-email').value.trim();
  var isGift      = document.getElementById('is-gift').checked;
  var senderName  = isGift ? document.getElementById('sender-name').value.trim()  : '';
  var giftMessage = isGift ? document.getElementById('gift-message').value.trim() : '';

  if (!certName)  { alert('Please enter the name for the certificate.'); document.getElementById('cert-name').focus(); return; }
  if (!certEmail) { alert('Please enter the email address.'); document.getElementById('cert-email').focus(); return; }
  if (isGift && !senderName) { alert('Please enter your name in the gift sender section.'); document.getElementById('sender-name').focus(); return; }

  // Look up variant ID from Liquid-injected map
  var variantId = variantMap[curPreset.variantTitle];
  if (!variantId) {
    console.error('[KAT] Variant not found for:', curPreset.variantTitle, 'Map:', variantMap);
    alert('Setup issue: variant not found for "' + curPreset.variantTitle + '".\n\nCheck browser console (F12) and verify Shopify variant titles match exactly.');
    return;
  }

  var props = {
    'Certificate Name':  certName,
    'Certificate Email': certEmail,
    'Location':          LOCS[curLoc].label,
    'Trees':             curPreset.qty,
    'Is Gift':           isGift ? 'Yes' : 'No'
  };
  if (isGift && senderName)  props['Sender Name']  = senderName;
  if (isGift && giftMessage) props['Gift Message'] = giftMessage;

  var btn  = document.getElementById('atc-btn');
  var orig = btn.innerHTML;
  btn.textContent = 'Adding...';
  btn.disabled    = true;

  fetch('/cart/add.js', {
    method:  'POST',
    headers: {'Content-Type':'application/json'},
    // quantity: 1 because the variant IS the quantity (US Tree / 25 = 1 unit at $225)
    body:    JSON.stringify({ id: variantId, quantity: 1, properties: props })
  })
  .then(function(r) {
    return r.json().then(function(data) {
      if (!r.ok) throw new Error((data.description || data.message || JSON.stringify(data)) + ' (HTTP ' + r.status + ')');
      return data;
    });
  })
  .then(function() { window.location.href = '/cart'; })
  .catch(function(err) {
    console.error('[KAT] Cart error:', err);
    btn.innerHTML = orig;
    btn.disabled  = false;
    alert('Could not add to cart:\n\n' + err.message);
  });
}

// ── ACCORDION ─────────────────────────────────────────────────────
window.accord = function(el) {
  var a = el.nextElementSibling, open = a.classList.contains('open');
  document.querySelectorAll('.accord-a').forEach(function(x){ x.classList.remove('open'); });
  document.querySelectorAll('.accord-q').forEach(function(x){ x.classList.remove('open'); });
  if (!open) { a.classList.add('open'); el.classList.add('open'); }
}

document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCert(); });

// Init on load
syncUI();

}); // end DOMContentLoaded